import { AxiosResponse } from 'axios';
import { APICallInstance } from './APICallInstance';
import { RegionResponse } from 'Application/models';

const regionUrl = 'api/v1/region';

export const getRegions = async () => {
    try {
        const response: AxiosResponse<RegionResponse> = await APICallInstance.get(`${regionUrl}/all`);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
